import type { JSX } from "react";
import { useComposerValue } from "./composer-context";
import { SendControl, type SendButtonProps } from "./SendControl";

export type { SendButtonProps };

/** The send control of `<Editor>`'s composer, which reads how the draft stands from its store. */
export function SendButton({ labels, submit }: SendButtonProps): JSX.Element {
  const sending = useComposerValue("pending");
  const empty = useComposerValue("empty");
  return <SendControl labels={labels} submit={submit} sending={sending} empty={empty} />;
}
